import React, { useLayoutEffect, useRef } from 'react';
import { sanitizeClientNoteHtml } from './clientNoteRichText';

export default function RichNoteEditor({ value, onChange, onBlur, label, error, readOnly = false }) {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const html = sanitizeClientNoteHtml(value);
    // Avoid resetting the selection on each keystroke; sync external changes only.
    if (ref.current && sanitizeClientNoteHtml(ref.current.innerHTML) !== html) ref.current.innerHTML = html;
  }, [value]);
  return <>
    <label id="client-note-rich-label">{label}</label>
    <div ref={ref} role="textbox" aria-labelledby="client-note-rich-label" aria-multiline="true"
      aria-invalid={Boolean(error)} contentEditable={!readOnly} aria-readonly={readOnly} suppressContentEditableWarning
      className="form-control note-textarea" style={{ minHeight: 180, whiteSpace: 'pre-wrap' }}
      onInput={event => onChange(sanitizeClientNoteHtml(event.currentTarget.innerHTML))}
      onBlur={onBlur}
      onDrop={event => event.preventDefault()}
      onPaste={event => {
        // Insert a sanitized fragment, never clipboard HTML into the live DOM.
        event.preventDefault();
        if (readOnly) return;
        const clipboardHtml = event.clipboardData.getData('text/html');
        const template = document.createElement('template');
        if (clipboardHtml) template.innerHTML = sanitizeClientNoteHtml(clipboardHtml);
        else template.content.appendChild(document.createTextNode(event.clipboardData.getData('text/plain')));
        const selection = window.getSelection();
        if (!selection?.rangeCount) return;
        const range = selection.getRangeAt(0);
        if (!ref.current.contains(range.commonAncestorContainer)) return;
        range.deleteContents();
        const last = template.content.lastChild;
        range.insertNode(template.content);
        if (last) { range.setStartAfter(last); range.collapse(true); selection.removeAllRanges(); selection.addRange(range); }
        onChange(sanitizeClientNoteHtml(ref.current.innerHTML));
      }} />
    {error && <div className="text-danger" role="alert">{error}</div>}
  </>;
}
